export const agentMessages = {
  en: {
    navigation: 'Agents',
    eyebrow: 'Master data',
    title: 'Agent master',
    description: 'Manage the B2B travel companies used throughout the CRM.',
    quickCreate: {
      title: 'Quick-create Agent',
      description: 'Add the basic company details now. More details can be added later.',
    },
    actions: {
      close: 'Close',
      cancel: 'Cancel',
      create: 'Create Agent',
      quickCreate: 'Quick create',
      edit: 'Edit',
      save: 'Save',
      saving: 'Saving…',
      retry: 'Retry',
      activate: 'Activate',
      deactivate: 'Deactivate',
      previous: 'Previous',
      next: 'Next',
      refresh: 'Refresh latest version',
    },
    filters: {
      search: 'Search name, code, email, or phone',
      countryCode: 'Country code',
      currency: 'Currency',
      allStatuses: 'All statuses',
    },
    columns: {
      agent: 'Agent',
      code: 'Code',
      countryMarket: 'Country / market',
      email: 'Email',
      phone: 'Phone',
      currency: 'Currency',
      status: 'Status',
      actions: 'Actions',
    },
    status: { active: 'Active', inactive: 'Inactive' },
    states: {
      loading: 'Loading Agents…',
      loadingDetail: 'Loading Agent details…',
      emptyTitle: 'No Agents found',
      emptyDescription: 'Create an Agent or change the filters to continue.',
    },
    sections: {
      basic: 'Basic details',
      communication: 'Communication',
      address: 'Address',
      legal: 'Legal details',
      internal: 'Internal notes',
    },
    fields: {
      name: 'Company name',
      code: 'Agent code',
      countryCode: 'Country code',
      market: 'Market',
      preferredCurrency: 'Preferred currency',
      email: 'Email',
      phone: 'Phone',
      addressLine1: 'Address line 1',
      addressLine2: 'Address line 2',
      city: 'City',
      stateRegion: 'State / region',
      postalCode: 'Postal code',
      taxNumber: 'Tax number',
      registrationNumber: 'Registration number',
      notes: 'Notes',
    },
    validation: {
      nameRequired: 'Company name is required.',
      codeFormat: 'Use letters, numbers, and underscores; start with a letter.',
      countryCodeFormat: 'Use a two-letter country code.',
      currencyFormat: 'Use a three-letter currency code.',
      emailFormat: 'Enter a valid email address.',
    },
    errors: {
      list: 'Agents could not be loaded.',
      load: 'Agent details could not be loaded.',
      create: 'Agent could not be created.',
      save: 'Agent could not be saved.',
      status: 'Agent status could not be changed.',
      validation: 'Check the entered Agent details and try again.',
      codeExists: 'This Agent code is already in use.',
      versionConflict: 'This Agent changed elsewhere. Refresh before saving again.',
    },
    messages: {
      created: 'Agent created.',
      updated: 'Agent updated.',
      activated: 'Agent activated.',
      deactivated: 'Agent deactivated.',
    },
  },
  ja: {
    navigation: 'エージェント',
    eyebrow: 'マスターデータ',
    title: 'エージェントマスター',
    description: 'CRM全体で使用するB2B旅行会社を管理します。',
    quickCreate: {
      title: 'エージェントを簡易登録',
      description: '会社の基本情報を登録します。詳細は後から追加できます。',
    },
    actions: {
      close: '閉じる',
      cancel: 'キャンセル',
      create: 'エージェントを作成',
      quickCreate: '簡易登録',
      edit: '編集',
      save: '保存',
      saving: '保存中…',
      retry: '再試行',
      activate: '有効化',
      deactivate: '無効化',
      previous: '前へ',
      next: '次へ',
      refresh: '最新版を再読込',
    },
    filters: {
      search: '名前、コード、メール、電話を検索',
      countryCode: '国コード',
      currency: '通貨',
      allStatuses: 'すべての状態',
    },
    columns: {
      agent: 'エージェント',
      code: 'コード',
      countryMarket: '国／市場',
      email: 'メール',
      phone: '電話',
      currency: '通貨',
      status: '状態',
      actions: '操作',
    },
    status: { active: '有効', inactive: '無効' },
    states: {
      loading: 'エージェントを読み込み中…',
      loadingDetail: 'エージェント詳細を読み込み中…',
      emptyTitle: 'エージェントが見つかりません',
      emptyDescription: 'エージェントを作成するか、フィルターを変更してください。',
    },
    sections: {
      basic: '基本情報',
      communication: '連絡先',
      address: '住所',
      legal: '法的情報',
      internal: '社内メモ',
    },
    fields: {
      name: '会社名',
      code: 'エージェントコード',
      countryCode: '国コード',
      market: '市場',
      preferredCurrency: '希望通貨',
      email: 'メール',
      phone: '電話',
      addressLine1: '住所1',
      addressLine2: '住所2',
      city: '市区町村',
      stateRegion: '都道府県／地域',
      postalCode: '郵便番号',
      taxNumber: '税番号',
      registrationNumber: '登録番号',
      notes: 'メモ',
    },
    validation: {
      nameRequired: '会社名は必須です。',
      codeFormat: '先頭を英字にし、英数字とアンダースコアを使用してください。',
      countryCodeFormat: '2文字の国コードを入力してください。',
      currencyFormat: '3文字の通貨コードを入力してください。',
      emailFormat: '有効なメールアドレスを入力してください。',
    },
    errors: {
      list: 'エージェントを読み込めませんでした。',
      load: 'エージェント詳細を読み込めませんでした。',
      create: 'エージェントを作成できませんでした。',
      save: 'エージェントを保存できませんでした。',
      status: 'エージェントの状態を変更できませんでした。',
      validation: '入力したエージェント情報を確認して、もう一度お試しください。',
      codeExists: 'このエージェントコードは既に使用されています。',
      versionConflict: '他で更新されています。最新版を再読込してから保存してください。',
    },
    messages: {
      created: 'エージェントを作成しました。',
      updated: 'エージェントを更新しました。',
      activated: 'エージェントを有効化しました。',
      deactivated: 'エージェントを無効化しました。',
    },
  },
  'zh-TW': {
    navigation: '代理商',
    eyebrow: '主資料',
    title: '代理商主檔',
    description: '管理整個CRM使用的B2B旅遊公司。',
    quickCreate: {
      title: '快速建立代理商',
      description: '先加入公司基本資料，其他資料可稍後補充。',
    },
    actions: {
      close: '關閉',
      cancel: '取消',
      create: '建立代理商',
      quickCreate: '快速建立',
      edit: '編輯',
      save: '儲存',
      saving: '儲存中…',
      retry: '重試',
      activate: '啟用',
      deactivate: '停用',
      previous: '上一頁',
      next: '下一頁',
      refresh: '重新載入最新版本',
    },
    filters: {
      search: '搜尋名稱、代碼、電子郵件或電話',
      countryCode: '國家代碼',
      currency: '幣別',
      allStatuses: '所有狀態',
    },
    columns: {
      agent: '代理商',
      code: '代碼',
      countryMarket: '國家／市場',
      email: '電子郵件',
      phone: '電話',
      currency: '幣別',
      status: '狀態',
      actions: '操作',
    },
    status: { active: '啟用', inactive: '停用' },
    states: {
      loading: '正在載入代理商…',
      loadingDetail: '正在載入代理商詳細資料…',
      emptyTitle: '找不到代理商',
      emptyDescription: '請建立代理商或變更篩選條件。',
    },
    sections: {
      basic: '基本資料',
      communication: '聯絡方式',
      address: '地址',
      legal: '法務資料',
      internal: '內部備註',
    },
    fields: {
      name: '公司名稱',
      code: '代理商代碼',
      countryCode: '國家代碼',
      market: '市場',
      preferredCurrency: '偏好幣別',
      email: '電子郵件',
      phone: '電話',
      addressLine1: '地址第1行',
      addressLine2: '地址第2行',
      city: '城市',
      stateRegion: '州／地區',
      postalCode: '郵遞區號',
      taxNumber: '稅務編號',
      registrationNumber: '登記編號',
      notes: '備註',
    },
    validation: {
      nameRequired: '公司名稱為必填。',
      codeFormat: '請以英文字母開頭，並只使用英數字與底線。',
      countryCodeFormat: '請使用兩個字母的國家代碼。',
      currencyFormat: '請使用三個字母的幣別代碼。',
      emailFormat: '請輸入有效的電子郵件地址。',
    },
    errors: {
      list: '無法載入代理商。',
      load: '無法載入代理商詳細資料。',
      create: '無法建立代理商。',
      save: '無法儲存代理商。',
      status: '無法變更代理商狀態。',
      validation: '請檢查輸入的代理商資料後再試一次。',
      codeExists: '此代理商代碼已被使用。',
      versionConflict: '此代理商已在其他地方更新。請重新載入後再儲存。',
    },
    messages: {
      created: '代理商已建立。',
      updated: '代理商已更新。',
      activated: '代理商已啟用。',
      deactivated: '代理商已停用。',
    },
  },
  ko: {
    navigation: '에이전트',
    eyebrow: '마스터 데이터',
    title: '에이전트 마스터',
    description: 'CRM 전반에서 사용하는 B2B 여행사를 관리합니다.',
    quickCreate: {
      title: '에이전트 빠른 생성',
      description: '회사 기본 정보를 먼저 추가하고 상세 정보는 나중에 입력할 수 있습니다.',
    },
    actions: {
      close: '닫기',
      cancel: '취소',
      create: '에이전트 생성',
      quickCreate: '빠른 생성',
      edit: '편집',
      save: '저장',
      saving: '저장 중…',
      retry: '다시 시도',
      activate: '활성화',
      deactivate: '비활성화',
      previous: '이전',
      next: '다음',
      refresh: '최신 버전 새로고침',
    },
    filters: {
      search: '이름, 코드, 이메일 또는 전화 검색',
      countryCode: '국가 코드',
      currency: '통화',
      allStatuses: '모든 상태',
    },
    columns: {
      agent: '에이전트',
      code: '코드',
      countryMarket: '국가 / 시장',
      email: '이메일',
      phone: '전화',
      currency: '통화',
      status: '상태',
      actions: '작업',
    },
    status: { active: '활성', inactive: '비활성' },
    states: {
      loading: '에이전트 불러오는 중…',
      loadingDetail: '에이전트 상세 정보 불러오는 중…',
      emptyTitle: '에이전트가 없습니다',
      emptyDescription: '에이전트를 생성하거나 필터를 변경하세요.',
    },
    sections: {
      basic: '기본 정보',
      communication: '연락처',
      address: '주소',
      legal: '법적 정보',
      internal: '내부 메모',
    },
    fields: {
      name: '회사명',
      code: '에이전트 코드',
      countryCode: '국가 코드',
      market: '시장',
      preferredCurrency: '선호 통화',
      email: '이메일',
      phone: '전화',
      addressLine1: '주소 1',
      addressLine2: '주소 2',
      city: '도시',
      stateRegion: '주 / 지역',
      postalCode: '우편번호',
      taxNumber: '세금 번호',
      registrationNumber: '등록 번호',
      notes: '메모',
    },
    validation: {
      nameRequired: '회사명은 필수입니다.',
      codeFormat: '문자로 시작하고 문자, 숫자, 밑줄만 사용하세요.',
      countryCodeFormat: '두 글자 국가 코드를 사용하세요.',
      currencyFormat: '세 글자 통화 코드를 사용하세요.',
      emailFormat: '올바른 이메일 주소를 입력하세요.',
    },
    errors: {
      list: '에이전트를 불러오지 못했습니다.',
      load: '에이전트 상세 정보를 불러오지 못했습니다.',
      create: '에이전트를 생성하지 못했습니다.',
      save: '에이전트를 저장하지 못했습니다.',
      status: '에이전트 상태를 변경하지 못했습니다.',
      validation: '입력한 에이전트 정보를 확인한 후 다시 시도하세요.',
      codeExists: '이 에이전트 코드는 이미 사용 중입니다.',
      versionConflict: '다른 곳에서 변경되었습니다. 새로고침 후 다시 저장하세요.',
    },
    messages: {
      created: '에이전트를 생성했습니다.',
      updated: '에이전트를 업데이트했습니다.',
      activated: '에이전트를 활성화했습니다.',
      deactivated: '에이전트를 비활성화했습니다.',
    },
  },
} as const;
